<template>
  <store-recherche-provider
    name="bonStockEntree"
    :copy="bonStore">
    <listeBonStock :isEntree="true"/>
  </store-recherche-provider>
</template>

<script>
import listeBonStock from '@/components/bonStock/listeBonStock';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import bonStore from '@/store/modules/gabed/bonStock';

export default {
  data() {
    return {
      bonStore,
    };
  },
  components: {
    listeBonStock,
    storeRechercheProvider,
  },
  mounted() {
    this.setInformationPage(this.$t('pageStock.bonStock.liste', { bons: 'bons d\'entrée' }));
  },
};
</script>
